import loadable from '@loadable/component';

import LoadingPage from '../../../components/LoadingPage';

const LoadablePrepayClaimsPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadablePrepayClaimsPage;
